// src/components/Footer.tsx
import React from "react";
import { Box, Grid, Typography } from "@material-ui/core";

const Footer: React.FC = () => {
    return (
            <Box bgcolor="#0b0e14" color="white" py={4} textAlign="center" className="mt60">
                <Grid container spacing={2} justify="center">
                    <Grid item xs={12} md={8}>
                        <Typography variant="caption" className="f14 colorWhite">
                            Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go
                            here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers
                            go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal
                            disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here.
                            Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go here. Legal disclaimers go
                            here. Legal disclaimers go here. Legal disclaimers go here.
                        </Typography>
                        <Typography variant="caption">
                            Terms & Support | Legal Disclaimers
                        </Typography>
                    </Grid>

                </Grid>

            </Box>
    );
};

export default Footer;
